import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Scrollbar } from 'src/components/atoms/scrollbar';
import AvatarWithInfo from 'src/components/molecules/avatar-with-info';

import { Alert } from '../../api/types/alert';

import { DataStatusIndicator } from '@/components/molecules/data-status-indicator/data-status-indicator';

interface Props {
  data: Alert[];
  isLoading: boolean;
  error: string;
}
export const AccessControlEventsTable: FC<Props> = ({ data, isLoading, error }) => {
  const { t } = useTranslation(['accessControlEvents']);

  const columns = [
    {
      id: 'avatar',
      column: t('accessControlEvents:name'),
    },
    {
      id: 'leftAt',
      column: t('accessControlEvents:leftAt'),
    },
    {
      id: 'reason',
      column: t('accessControlEvents:reason'),
    },
    {
      id: 'expectedToLeaveAt',
      column: t('accessControlEvents:expectedToLeaveAt'),
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
      }}>
      <Scrollbar>
        <Table sx={{ minWidth: 1000 }}>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id}>{column.column}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map(({ occurredAt, invalidatedAt, visitor, reason, id }) => (
              <TableRow key={id}>
                <TableCell>
                  <AvatarWithInfo
                    avatarText={`${visitor.firstName.slice(0, 1)} ${visitor.lastName.slice(0, 1)}`}
                    primaryText={`${visitor.firstName} ${visitor.lastName}`}
                    secondaryText={visitor?.email}
                    src=""
                  />{' '}
                </TableCell>
                <TableCell>
                  <Chip
                    variant="outlined"
                    color="error"
                    label={t(`accessControlEvents:${reason}`)}
                  />
                </TableCell>
                <TableCell>
                  <Typography color="inherit" variant="inherit">
                    {format(new Date(occurredAt), 'dd MMM yyyy')}
                  </Typography>
                  <Typography color="textSecondary" variant="inherit">
                    {format(new Date(occurredAt), 'HH:mm')}
                  </Typography>
                </TableCell>

                <TableCell>
                  {invalidatedAt ? (
                    <>
                      <Typography color="inherit" variant="inherit">
                        {format(new Date(invalidatedAt), 'dd MMM yyyy')}
                      </Typography>
                      <Typography color="textSecondary" variant="inherit">
                        {format(new Date(invalidatedAt), 'HH:mm')}
                      </Typography>
                    </>
                  ) : (
                    <Typography variant="inherit" color="error">
                      {t('accessControlEvents:leftError')}
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Scrollbar>
      <DataStatusIndicator dataLength={data?.length} error={error} isFetching={isLoading} />
    </Box>
  );
};
